"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import { InputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import "../../../utilities/layout/Row.js";
import "@gnist/themes/tokens.css.js";
import "react-content-loader";
import { useState } from "react";
import { useSelectInputLogic, getSelectInputProps } from "../shared.js";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import "../../../foundation/typography/index.js";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { Select, Option } from "@mui/base";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import "../../actions/buttons/PrimaryButton.js";
import "../../actions/buttons/SecondaryButton.js";
import "../../actions/buttons/SuccessButton.js";
import "../../actions/buttons/DangerButton.js";
import "../../actions/buttons/GhostButton.js";
import "../../actions/buttons/TextButton.js";
import "../../actions/buttons/IconButton.js";
import { Checkbox } from "../../actions/selectionControls/Checkbox.js";
import "../../actions/selectionControls/RadioButton.js";
import "../../actions/chips/ActionChip.js";
import "../../actions/chips/FilterChip.js";
import "../../actions/chips/TagChip.js";
import { wrapperStyle, inputFieldWrapperRecipe, inputContentWrapper } from "../shared-styles/inputField.css.js";
import { preInputWidth, postInputWidth } from "../shared-styles/inputFieldConstants.css.js";
import { labelStyle } from "../shared-styles/labelStyles.css.js";
import { listBoxStyle, popUpStyle, selectStyle, optionStyle, optionBackground, singleOptionStyle } from "./select.css.js";
const listBoxComponent = component("listBox", listBoxStyle, "div");
const popUpComponent = component("popUp", popUpStyle, "div");
function SelectBase(props, isMultiple, ref) {
  var _a, _b;
  const { contentProps, wrapperProps, commonInputProps } = useSelectInputLogic(props);
  const { selectProps } = getSelectInputProps(props);
  const [isExpanded, setIsExpanded] = useState(false);
  return jsxs("span", { ref, className: classNames(wrapperProps.className, wrapperStyle), children: [jsxs("label", { htmlFor: props.id, className: inputFieldWrapperRecipe({
    disabled: props.disabled,
    density: props.density,
    validityType: (_a = props.validity) == null ? void 0 : _a.type
  }), children: [jsx(Select, { className: selectStyle, style: {
    ...assignInlineVars({
      [preInputWidth]: wrapperProps.preInputWidth,
      [postInputWidth]: wrapperProps.postInputWidth
    })
  }, ...commonInputProps, ...selectProps, ref, multiple: isMultiple, onListboxOpenChange: (expanded) => setIsExpanded(expanded), slots: {
    listbox: listBoxComponent,
    popup: popUpComponent
  }, onChange: (e, value) => {
    var _a2;
    (_a2 = selectProps.onChange) == null ? void 0 : _a2.call(selectProps, value);
  }, children: props.options.map((option) => {
    var _a2;
    return jsxs(Option, { value: option.value, className: optionStyle, children: [jsx("div", { className: optionBackground }), isMultiple ? jsx(Checkbox, { label: option.label, value: Array.isArray(props.value) && ((_a2 = props.value) == null ? void 0 : _a2.includes(option.value)), readOnly: true, tabIndex: -1 }) : jsxs("div", { className: singleOptionStyle, children: [jsx("p", { children: option.label }), typeof props.value === "string" && props.value === option.value && jsx(Icon, { icon: "check" })] })] }, option.value);
  }) }), jsxs("span", { className: inputContentWrapper({ density: props.density }), children: [props.leadingIcon && jsx(Icon, { icon: props.leadingIcon, className: atoms({
    paddingRight: "xxs",
    color: props.disabled ? "on-disabled" : "on-surface"
  }) }), jsx("label", { id: contentProps.labelId, className: labelStyle({
    density: props.density,
    validityType: (_b = props.validity) == null ? void 0 : _b.type,
    isElevated: !!props.value,
    disabled: props.disabled
  }), style: {
    ...assignInlineVars({
      [preInputWidth]: wrapperProps.preInputWidth
    })
  }, children: jsx("span", { style: { position: "relative" }, children: props.label }) }), jsx("span", { style: { flexGrow: "1" } }), jsx(Icon, { icon: isExpanded ? "expand_less" : "expand_more", className: atoms({
    paddingLeft: "xxs",
    color: props.disabled ? "on-disabled" : "on-surface"
  }) })] })] }), jsx(InputHelperText, { id: contentProps.helperId, validity: props.validity, helperText: props.helperText, disabled: props.disabled })] });
}
export {
  SelectBase
};
